import style from "./mailVerify.module.css";
import Lottie from "react-lottie";
import successAnim from "../../../lotties/mail_verify_sucess.json";
import bgImage from "../../../assets/img/Email_campaign_pana.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { validateEmail } from "../../../adapters/apis/auth/auth";


function MailVerify() {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const email = query.get("email");
  const contextMapping = {
    register:{text:"العودة إلى الصفحة الرئيسية", link:"/login"},
    login_verify:{text:"العودة إلى الصفحة الرئيسية", link:"/"},
    profile:{text:"العودة إلى الشاشة السابقة", link:"/profile"},

  }
  
const context = sessionStorage.getItem("context");
const { text, link } = contextMapping[context];

  const defaultOptions = {
    loop: true,
    autoplay: true,
    speed: 1,
    animationData: successAnim,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

const handleResend = async (e) => {
  e.preventDefault();
  try {
      setLoading(true);
      validateEmail({ email: email })
      .then((res) => {
          setMessage(res.data.message);
          navigate(`/mail-verify?email=${email}`);
          setLoading(false)
      })
      .catch((error) => {
          setMessage(error?.response?.data?.message || "حدث خطأ أثناء إرسال البريد");
          setLoading(false)
      })
  } catch (err) {
      setMessage("حدث خطأ أثناء إرسال البريد");
      setLoading(false)

  } finally {
      setLoading(false);
  }
};
  return (
    <div className={style.verifyContainer}>
      <div className={style.verifyCard}>
        <img src={bgImage} className={style.verifyBg} alt="" />

        <Lottie options={defaultOptions} />

        <h3 className={style.verifyTitle}>
          تم إرسال بريد تفعيل البريد الإلكتروني الخاص بك إلى بريدك الإلكتروني
        </h3>

        <button
          className={style.verifyBtn}
          onClick={() => navigate(link)}
        >
        {text}
        </button>

        
        <a href="#" className={loading ? style.disabledLink : style.verifyResend} onClick={handleResend} disabled={loading}>          
        إرسال بريد تفعيل البريد الإلكتروني مرة أخرى
        </a>
        {message && (
          <div className="alert alert-primary mt-4" role="alert">
            {message}
          </div>
        )}
      </div>
    </div>
  );
}

export default MailVerify;
